import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Upload } from "lucide-react";

interface SignatureFormData {
  name: string;
  title: string;
  phone: string;
  email: string;
  calUrl: string;
  photoUrl: string;
  photoPreview: string;
}

interface SignatureFormProps {
  formData: SignatureFormData;
  onChange: (data: SignatureFormData) => void;
}

const SignatureForm = ({ formData, onChange }: SignatureFormProps) => {
  const handleChange = (field: keyof SignatureFormData, value: string) => {
    onChange({ ...formData, [field]: value });
  };

  const handlePhotoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (ev) => {
      const dataUrl = ev.target?.result as string;
      onChange({ ...formData, photoPreview: dataUrl, photoUrl: dataUrl });
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="bg-muted rounded-lg p-6 space-y-4">
      <h2 className="text-lg font-semibold mb-2">Informations</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="name">Nom complet</Label>
          <Input
            id="name"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            placeholder="Maxim Rousseau"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="title">Titre / Poste</Label>
          <Input
            id="title"
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
            placeholder="Fondateur"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">Téléphone</Label>
          <Input
            id="phone"
            value={formData.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
            placeholder="819-460-9725"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Courriel</Label>
          <Input
            id="email"
            type="email"
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            placeholder="maxim@agence8020.com"
          />
        </div>
        <div className="space-y-2 md:col-span-2">
          <Label htmlFor="calUrl">Lien Cal.com (rendez-vous)</Label>
          <Input
            id="calUrl"
            value={formData.calUrl}
            onChange={(e) => handleChange("calUrl", e.target.value)}
            placeholder="https://cal.com/votre-lien/30min"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="photo">Photo de profil</Label>
        <div className="flex items-center gap-4">
          <label
            htmlFor="photo"
            className="flex items-center gap-2 px-4 py-2 rounded-md border border-input bg-background cursor-pointer hover:bg-accent/10 transition-colors text-sm"
          >
            <Upload className="w-4 h-4" />
            Choisir une photo
          </label>
          <input
            id="photo"
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handlePhotoUpload}
          />
          {formData.photoPreview && (
            <img
              src={formData.photoPreview}
              alt="Preview"
              className="w-12 h-12 rounded-md object-cover border"
            />
          )}
        </div>
        <p className="text-xs text-muted-foreground">
          ⚠️ Pour le code HTML exporté, vous devrez héberger la photo en ligne et remplacer l'URL dans le code.
        </p>
      </div>
    </div>
  );
};

export default SignatureForm;
